<script lang="ts">
  //eslint-disable-next-line
  type ProductListItem = $$Generic;
  export let products: ProductListItem[];

  const breakpoints = {
    default: '720px',
    'min-768': `calc(100vw - 4rem)`,
  };
</script>

<ul class="w-full">
  {#each products as product}
    <li class="mb-6 w-full">
      <slot {product} {breakpoints} />
    </li>
  {/each}
</ul>
